var _path, _path2, _path3, _circle, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListUnordered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9357 3.60005H7.53574C7.42966 3.60005 7.32791 3.5579 7.2529 3.48289C7.17788 3.40787 7.13574 3.30614 7.13574 3.20005C7.13574 3.09396 7.17788 2.99221 7.2529 2.9172C7.32791 2.84219 7.42966 2.80005 7.53574 2.80005H13.9357C14.0418 2.80005 14.1436 2.84219 14.2186 2.9172C14.2936 2.99221 14.3357 3.09396 14.3357 3.20005C14.3357 3.30614 14.2936 3.40787 14.2186 3.48289C14.1436 3.5579 14.0418 3.60005 13.9357 3.60005Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9357 8.4001H7.53574C7.42966 8.4001 7.32791 8.35795 7.2529 8.28293C7.17788 8.20792 7.13574 8.10618 7.13574 8.0001C7.13574 7.89401 7.17788 7.79226 7.2529 7.71725C7.32791 7.64223 7.42966 7.6001 7.53574 7.6001H13.9357C14.0418 7.6001 14.1436 7.64223 14.2186 7.71725C14.2936 7.79226 14.3357 7.89401 14.3357 8.0001C14.3357 8.10618 14.2936 8.20792 14.2186 8.28293C14.1436 8.35795 14.0418 8.4001 13.9357 8.4001Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9357 13.2001H7.53574C7.42966 13.2001 7.32791 13.158 7.2529 13.083C7.17788 13.008 7.13574 12.9062 7.13574 12.8001C7.13574 12.6941 7.17788 12.5923 7.2529 12.5173C7.32791 12.4423 7.42966 12.4001 7.53574 12.4001H13.9357C14.0418 12.4001 14.1436 12.4423 14.2186 12.5173C14.2936 12.5923 14.3357 12.6941 14.3357 12.8001C14.3357 12.9062 14.2936 13.008 14.2186 13.083C14.1436 13.158 14.0418 13.2001 13.9357 13.2001Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.60039,
    cy: 3.2,
    r: 1.2,
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.60039,
    cy: 8.00005,
    rx: 1.2,
    ry: 1.2,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.60039,
    cy: 12.8001,
    rx: 1.2,
    ry: 1.2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListUnordered);
export default __webpack_public_path__ + "static/media/list-unordered.3347401e74a71eb34d9c303eb7ba8c1f.svg";
export { ForwardRef as ReactComponent };